import { useUserRole } from "@/hooks/useUserRole";
import { useIsMobile } from "@/hooks/use-mobile";
import { useIsNativeApp } from "@/components/NativeAppLayout";
import { isNativePlatform } from "@/hooks/useIsNative";

export function useIsDesktopAdmin() {
  const { isAdmin, loading } = useUserRole();
  const isMobile = useIsMobile();
  const isNativeApp = useIsNativeApp();

  const isDesktopAdmin = isAdmin && !isNativeApp && !isNativePlatform() && !isMobile;

  return { isDesktopAdmin, loading };
}
